import React from 'react';
import PropTypes from 'prop-types';

import ClientLeadDescriptionEdit from './ClientLeadDescriptionEdit';
import ClientLeadDescriptionView from './ClientLeadDescriptionView';

const DescriptionBox = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    clientLeadData,
    clientLeadBackend,
  } = props;

  if (isEditing) {
    return (
      <ClientLeadDescriptionEdit
        clientLeadData={clientLeadData}
        clientLeadBackend={clientLeadBackend}
        setIsEditing={setIsEditing}
      />
    );
  } else {
    return (
      <ClientLeadDescriptionView
        clientLeadData={clientLeadData}
        setIsEditing={setIsEditing}
      />
    );
  }
};
DescriptionBox.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
};

export default React.memo(DescriptionBox);
